export default import.meta.ROLLDOWN_FILE_URL_OwQN_ehcd$a6YsxzYyGHsw